import type {TemplateResult} from 'lit';

export const DATATABLE_ACTION_ICON_STYLE =
    '--cbar-icon-size:18px;--md-icon-size:18px;font-size:18px;width:18px;height:18px';

export type DatatableIconAction = {
    href: string;
    label: string;
    icon: string;
    className?: string;
};

type LitHtml = (strings: TemplateStringsArray, ...values: unknown[]) => TemplateResult;

function isScriptHref(href: string): boolean {
    return href.trim().toLowerCase().startsWith('javascript:');
}

export function datatableIconAction(
    html: LitHtml,
    {href, label, icon, className = 'cleanlink datatable-action-link datatable-icon-button'}: DatatableIconAction,
): TemplateResult {
    const iconNode = html`<cbar-icon aria-hidden="true">${icon}</cbar-icon>`;

    if (isScriptHref(href)) {
        return html`<cbar-icon-button
            data-tooltip=${label}
            aria-label=${label}
            variant="standard"
            class=${className}
            href=${href}
        >${iconNode}</cbar-icon-button>`;
    }

    return html`<a
        data-tooltip=${label}
        aria-label=${label}
        class=${`${className} datatable-icon-button-wrap`}
        href=${href}
    ><cbar-icon-button variant="standard" tabindex="-1">${iconNode}</cbar-icon-button></a>`;
}

export function datatableIconActionsRow(html: LitHtml, actions: DatatableIconAction[]): TemplateResult {
    return html`<div class="datatable-actions datatable-actions--inline">
        ${actions.map((action) => datatableIconAction(html, action))}
    </div>`;
}

export function datatableViewEditResourcesActions(
    html: LitHtml,
    urls: {view: string; edit: string; update_resources: string},
    labels: {view?: string; edit?: string; resources?: string} = {},
): TemplateResult {
    return datatableIconActionsRow(html, [
        {href: urls.view, label: labels.view ?? 'View', icon: 'visibility'},
        {href: urls.edit, label: labels.edit ?? 'Edit', icon: 'edit'},
        {href: urls.update_resources, label: labels.resources ?? 'Update Resources', icon: 'settings'},
    ]);
}

export function datatableEditResourcesActions(
    html: LitHtml,
    urls: {update: string; resources: string},
    labels: {edit?: string; resources?: string} = {},
): TemplateResult {
    return datatableIconActionsRow(html, [
        {href: urls.update, label: labels.edit ?? 'Edit', icon: 'edit'},
        {href: urls.resources, label: labels.resources ?? 'Update Resources', icon: 'settings'},
    ]);
}
